module.exports = __webpack_public_path__ + "img/l.bf945892.jpg";